import { IAction } from '../utils';
import { collectionMocks, HeroSlidersMock } from '../../react-pages/HomePage/mock';
import { reducerTypes } from './types';
import { IBrand, IProduct } from '../../interfaces/product';
import { IPageInfo } from '../../interfaces/common';
import { FilterType, SuggestionType } from '../../react-pages/Catalog/types';

export interface IHomeReducer {
  brands: IBrand[];
  heroSlider: typeof HeroSlidersMock;
  collection: typeof collectionMocks;
  pageInfo: IPageInfo;
  homeProducts: IProduct[];
  products: IProduct[];
  productsMore: IProduct[];
  favorites: IProduct[];
  compareList: IProduct[];
  alsoLikedProducts: IProduct[];
  product?: IProduct;
  loading: boolean;
  filters: FilterType[];
  initialFilters: FilterType[];
  initialFiltersColl: FilterType[];
  suggestion: SuggestionType | undefined;
  sorting: string;
  priceValues: number[];
  selectedProducts: IProduct[];
  setSelectedCollectionTable: IProduct[];
}

export const INITIAL: IHomeReducer = {
  brands: [],
  heroSlider: HeroSlidersMock,
  collection: collectionMocks,
  pageInfo: {
    pageIndex: 0,
    totalPages: 0,
    totalCount: 0,
    pageSize: 12,
  },
  homeProducts: [],
  products: [],
  productsMore: [],
  favorites: [],
  compareList: [],
  alsoLikedProducts: [],
  loading: false,
  filters: [],
  initialFilters: [],
  initialFiltersColl: [],
  suggestion: undefined,
  sorting: '',
  priceValues: [],
  selectedProducts: [],
  setSelectedCollectionTable: [],
};

export const productReducer = (state = INITIAL, { type, payload }: IAction) => {
  switch (type) {
    case reducerTypes.IS_LOADING:
      return { ...state, loading: payload };
    case reducerTypes.GET_FILTERS:
      return { ...state, filters: payload };
    case reducerTypes.GET_INITIAL_FILTERS:
      return { ...state, initialFilters: payload };
    case reducerTypes.GET_HOME_PRODUCTS:
      return {
        ...state,
        homeProducts: payload,
      };
    case reducerTypes.SET_SELECTED_PRODUCTS:
      return {
        ...state,
        selectedProducts: payload,
      };
    case reducerTypes.SET_SELECTED_COLLECTION_TABLE:
      return {
        ...state,
        setSelectedCollectionTable: payload,
      };
    case reducerTypes.GET_ALL_PRODUCTS:
      return {
        ...state,
        products: payload,
        productsMore: payload,
        loading: false,
      };
    case reducerTypes.GET_MORE_PRODUCTS:
      return {
        ...state,
        productsMore: [...state.productsMore, ...payload],
        loading: false,
      };
    case reducerTypes.GET_FAVORITES:
      return {
        ...state,
        favorites: payload,
      };
    case reducerTypes.GET_COMPARE:
      return {
        ...state,
        compareList: payload,
      };
    case reducerTypes.GET_ALSO_LIKED_PRODUCTS:
      return { ...state, alsoLikedProducts: payload };
    case reducerTypes.GET_PRODUCT:
      return { ...state, product: payload, loading: false };
    case reducerTypes.SET_PAGE_INFO:
      return { ...state, pageInfo: payload };
    case reducerTypes.SET_PAGE_INDEX:
      return { ...state, pageInfo: { ...state.pageInfo, pageIndex: payload } };
    case reducerTypes.SET_PAGE_SIZE:
      return { ...state, pageInfo: { ...state.pageInfo, pageSize: payload } };
    case reducerTypes.SET_SORTING:
      return { ...state, sorting: payload };
    case reducerTypes.SET_PRICE_RANGE:
      return { ...state, priceValues: payload };
    case reducerTypes.GET_SUGGESTION:
      return { ...state, suggestion: payload };
    default:
      return state;
  }
};
